import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-long-up-right', 'ArrowLongUpRight', [["path",{"d":"M13 5h6m0 0v6m0-6L5 19","key":"svg-0"}]]);